import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { comparisonSearchData } from "../Redux/Slice/DataSlice";

const ComparisonSearch = () => {
  const { Cardetails } = useSelector((state) => state.CarData);
  const Dispatch = useDispatch();
  const [searchData1, setsearchData1] = useState("");
  const [searchData2, setsearchData2] = useState("");


  const SearchButton = () => {
    Dispatch(comparisonSearchData({searchData1:searchData1,searchData2:searchData2}));
    
  };


  return (
    <>
      <div className=" shadow-lg w-[100%] rounded-md flex flex-col justify-center items-center ">
        <div class="w-[100%] my-5">
          <div class="flex justify-center w-[100%]">
            <span className="text-2xl p-2 font-serif font-semibold text-black">
              Compare Your Dream CARS{" "}
            </span>
          </div>
        </div>

        <div class="w-[100%]   text-center sm:h-[10vh] h-[35vh] sm:flex-row flex-col flex justify-between items-center  ">
          <div class=" sm:w-[40%]  w-[90%]   flex  flex-col  justify-center items-center  ">
            <span className="text-lg p-2 font-serif font-semibold">
              Enter First Car Name{" "}
            </span>
            <input
              id="email"
              name="carName"
              list="Cars"
              value={searchData1}
              onChange={(e)=>setsearchData1(e.target.value)}
              type="search"
              class="  sm:w-[70%] w-[100%] rounded-md border border-black bg-black px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-black focus:outline-none focus:ring focus:ring-black focus:ring-opacity-40 "
              placeholder="Search Cars"
            />
            <datalist id="Cars">
              {Cardetails &&
                Cardetails.map((x) => {
                  return <option value={x.Name}>{x.Name}</option>;
                })}
            </datalist>
          </div>
          <div class="   w-[20%] flex flex-col justify-center items-center ">
            <div className="vs bg-red-500 shadow-lg shadow- shadow-red-600 text-white text-[30px] px-5 rounded-full">
              vs
            </div>
          </div>
          <div class=" sm:w-[40%]  w-[90%]   flex   flex-col justify-center items-center ">
            <span className="text-lg p-2 font-serif font-semibold">
              Enter Second Car Name{" "}
            </span>
            <input
              id="email"
              name="carName"
              list="Cars"
              value={searchData2}
              onChange={(e)=>setsearchData2(e.target.value)}
              type="search"
              class="  sm:w-[70%] w-[100%] rounded-md border border-black bg-black px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-black focus:outline-none focus:ring focus:ring-black focus:ring-opacity-40 sm:mx-2"
              placeholder="Search Cars"
            />
            <datalist id="Cars">
              {Cardetails &&
                Cardetails.map((x) => {
                  return <option value={x.Name}>{x.Name}</option>;
                })}
            </datalist>
          </div>
        </div>

        <div class="w-[100%]   my-5">
          <div class="flex justify-center w-[100%]">
            <button class="p-2  sm:w-1/4 w-[50%] rounded-md bg-green-500 shadow-lg shadow- shadow-green-600 text-white" onClick={SearchButton}>
              Search
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComparisonSearch;
